export function pushDataLayer(payload) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch {
    // Ignore analytics errors so UI never breaks.
  }
}

